import type { ReactNode } from 'react';

export const symbol_eraser_size_4: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M392.73-160Q296-160 228-228.02q-68-68.02-68-164.63Q160-438 176.5-481q16.5-43 51.5-77l173-174q35-34 77.85-51 42.85-17 88.16-17 96.54 0 164.77 68.22Q800-663.55 800-567.01q0 45.31-17 88.16Q766-436 732-401L558-228q-34 35-76.94 51.5-42.93 16.5-88.33 16.5Z"
		/>
	</svg>
);
